import { render, staticRenderFns } from "./NewsDialog.vue?vue&type=template&id=6f8d8c7d&scoped=true"
import script from "./NewsDialog.vue?vue&type=script&lang=js"
export * from "./NewsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8d8c7d",
  null
  
)

export default component.exports